import { Reference } from '@approvalmax/types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getNetSuiteContext } from '../../../../../selectors/netsuite/netSuiteSelectors';

export const useExpenseReportEmployeeCurrencies = (employee: Reference | null = null) => {
    const { currencies, employees } = useSelector(getNetSuiteContext);

    return useMemo(() => {
        if (employee) {
            const data = employees.find((el) => el.id === employee.id);

            if (data) {
                return currencies.filter((currency) => data.currencyIds.includes(currency.id));
            }
        }

        return currencies;
    }, [currencies, employee, employees]);
};
